import React from 'react'
import { object, string } from 'prop-types'
import styles from './EventSponsorHero.module.scss'
import cx from 'classnames'
import YouTubeEmbed from '@/component/Primitive/YouTubeEmbed'
import Container from '@/component/Primitive/Container'

export const EventSponsorHero = ({
  title,
  subtitle,
  backgroundVideoYoutubeId,
  backgroundImage,
  sponsor
}) => {
  const getImage = (context, ratio, size) =>
    sponsor?.images?.[`${context}_${ratio}_${size}`]

  const logo = getImage('logo', '1x1', 320)?.[0]

  return (
    <div
      className={cx(
        styles.EventSponsorHero,
        styles[`EventSponsorHero_${sponsor?.tier?.tierColour}`]
      )}
    >
      {backgroundVideoYoutubeId && (
        <div className={cx(styles.YoutubeEmbed)}>
          <YouTubeEmbed
            hideControls
            autoplay
            loop
            videoId={backgroundVideoYoutubeId}
          />
        </div>
      )}

      {backgroundImage && (
        <div className={styles.EventSponsorHeroImageHolder}>
          <img
            src={backgroundImage}
            className={cx(styles.EventSponsorHeroImage)}
            alt=""
          />
        </div>
      )}

      {sponsor && (
        <div className={styles.EventSponsorHeroContent}>
          <Container center size="large" gutter>
            <div className={styles.EventSponsorHeroContentRow}>
              {logo?.url && (
                <div className={styles.EventSponsorHeroContentLogo}>
                  <img
                    src={logo.url}
                    width={logo.width}
                    height={logo.height}
                    alt=""
                  />
                </div>
              )}

              <hgroup>
                {sponsor?.tier?.name && (
                  <p
                    className={cx(
                      styles.EventSponsorHeroContentTier,
                      sponsor.tier.rank === 1
                        ? styles.EventSponsorHeroContentTierTop
                        : null
                    )}
                  >
                    {sponsor.tier.name}
                  </p>
                )}
                <h1>{title || sponsor.displayName}</h1>
                {subtitle && (
                  <p className={styles.EventSponsorHeroContentSubTitle}>
                    {subtitle}
                  </p>
                )}
              </hgroup>
            </div>
          </Container>
        </div>
      )}
    </div>
  )
}

EventSponsorHero.propTypes = {
  title: string,
  subtitle: string,
  backgroundVideoYoutubeId: string,
  backgroundImage: string,
  sponsor: object
}
